export default __webpack_public_path__ + "static/media/km.ff5583b3.svg";